import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { IntranetComposeFab } from '@/products/intranet/components/intranet-compose-fab';
import { IntranetHeroExpandingSearch } from '@/products/intranet/components/intranet-feed-search';
import { useIntranetHomeWriteHref } from '@/products/intranet/features/intranet/use-intranet-home-write-href';

/** Search overlay on the hero (mobile). Channels live in the platform bottom nav. Compose FAB on start. */
export function IntranetHeroChromeHost({
  hero,
  children,
  showComposeFab = false,
  className,
}: {
  hero: ReactNode;
  children: ReactNode;
  showComposeFab?: boolean;
  className?: string;
}) {
  const writeHref = useIntranetHomeWriteHref();

  return (
    <>
      <div className={cn('relative shrink-0', className)}>
        {hero}
        <div className="pointer-events-none absolute inset-0 z-20 lg:hidden">
          <div className="flex min-w-0 items-start justify-end gap-2 px-3 pt-3">
            <div className="pointer-events-auto flex min-w-0 flex-1 justify-end">
              <IntranetHeroExpandingSearch />
            </div>
          </div>
        </div>
      </div>
      {children}
      {showComposeFab && writeHref ? <IntranetComposeFab writeHref={writeHref} /> : null}
    </>
  );
}
